import Vue from 'vue'
import Router from 'vue-router'
// import common from '@/assets/js/common.js'
import * as api from '@/api/book.js'
import shareApi from '@/assets/js/share.js'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      // 首页
      path: '/home',
      name: 'home',
      meta: {index: 0, allowBack: false},
      component: () => import('@/pages/home.vue')
    },
    {
      // 引导页
      path: '/onboarding',
      name: 'onboarding',
      meta: {index: 0, allowBack: false},
      component: () => import('@/pages/onboarding.vue')
    },
    {
      // 激活页
      path: '/pay/activate',
      name: 'activate',
      meta: {share: true},
      component: () => import('@/pages/pay/activate.vue')
    },
    {
      // 激活成功页
      path: '/pay/paySuccess',
      name: 'paySuccess',
      meta: {allowBack: false, share: true},
      component: () => import('@/pages/pay/pay_success.vue')
    },
    {
      // 课程列表
      path: '/course/list',
      name: 'courseList',
      component: () => import('@/pages/course/book/course_list.vue')
    },
    {
      // 我的课程
      path: '/course/mycourse',
      name: 'myCourse',
      component: () => import('@/pages/course/book/my_course.vue')
    },
    {
      // 章节列表
      path: '/course/chapter/:rtype/:rpid/:rid',
      name: 'chapterList',
      component: () => import('@/pages/course/book/chapter_list.vue')
    },
    {
      // 售卖页
      path: '/course/sale/:rtype/:rid',
      name: 'sale',
      component: () => import('@/pages/course/book/sale.vue')
    },
    {
      // 播放sid(section_id)oid(option_id)
      path: '/course/play/:rtype/:rpid/:rid/:sid/:oid?/:scid?',
      name: 'coursePlay',
      meta: {share: true},
      component: () => import('@/pages/course/book/course_play.vue')
    },
    {
      // 优惠券
      path: '/coupon',
      name: 'coupon',
      component: () => import('@/pages/coupon/coupon.vue')
    },
    {
      // 支付页
      path: '/coupon/apply',
      name: 'apply',
      component: () => import('@/pages/coupon/apply.vue')
    },
    {
      // 核销页from=1来源支付from=2来源于线下课程ca=1核销员身份
      path: '/coupon/writeoff',
      name: 'writeoff',
      component: () => import('@/pages/coupon/writeoff.vue')
    },
    {
      // 考试列表
      path: '/course/examlist',
      name: 'examList',
      component: () => import('@/pages/course/exam/exam_list.vue')
    },
    {
      // 考试题目
      path: '/course/exam_questions/:id/:t/:n',
      name: 'examQuestions',
      component: () => import('@/pages/course/exam/exam_questions.vue')
    },
    {
      // 考试结果
      path: '/course/exam_result/:id',
      name: 'examResult',
      component: () => import('@/pages/course/exam/exam_result.vue')
    },
    {
      // 个人中心
      path: '/mine',
      name: 'mine',
      component: () => import('@/pages/my/mine.vue')
    },
    {
      // 编辑个人信息
      path: '/my/edit',
      name: 'edit',
      component: () => import('@/pages/my/edit.vue')
    },
    {
      // 我的钱包
      path: '/my/wallet',
      name: 'wallet',
      component: () => import('@/pages/my/wallet.vue')
    },
    {
      // 交易记录
      path: '/my/bill',
      name: 'bill',
      component: () => import('@/pages/my/bill.vue')
    },
    {
      // 提现
      path: '/my/cashout',
      name: 'cashOut',
      component: () => import('@/pages/my/cash_out.vue')
    },
    {
      // 提现记录
      path: '/my/cashrecord',
      name: 'cashRecord',
      component: () => import('@/pages/my/cash_out_record.vue')
    },
    {
      // 提现明细
      path: '/my/cashdetail',
      name: 'cashDetail',
      component: () => import('@/pages/my/cash_out_detail.vue')
    },
    {
      // 我的日记
      path: '/my/diary',
      name: 'diary',
      component: () => import('@/pages/my/diary.vue')
    },
    {
      // 编辑日记、日记详情
      path: '/my/editdiary',
      name: 'diaryEdit',
      component: () => import('@/pages/my/diary_edit.vue')
    },
    {
      // 系统消息
      path: '/my/system',
      name: 'systemMessage',
      component: () => import('@/pages/my/system_message.vue')
    },
    {
      // 我的日历
      path: '/my/calendar/:rtype?/:rid?',
      name: 'myCalendar',
      component: () => import('@/pages/my/my_calendar.vue')
    },
    {
      // 意见反馈
      path: '/my/feedback',
      name: 'feedback',
      component: () => import('@/pages/my/feedback.vue')
    },
    {
      // 意见反馈详情
      path: '/my/feedback_detail',
      name: 'feedbackDetail',
      component: () => import('@/pages/my/feedback_detail.vue')
    },
    {
      // 书签
      path: '/course/bookmark',
      name: 'bookMark',
      component: () => import('@/pages/my/book_mark.vue')
    },
    {
      // 实名认证
      path: '/my/certification',
      name: 'certification',
      component: () => import('@/pages/my/certification.vue')
    },
    {
      // 首页
      path: '/read/index',
      name: 'bookIndex',
      component: () => import('@/pages/read/book/book_index.vue')
    },
    {
      // 共读播放页
      path: '/read/play',
      // /:pid/:bid
      name: 'play',
      meta: {share: true},
      component: () => import('@/pages/read/book/book_play.vue')
    },
    {
      // 共读专区
      path: '/read/ranking',
      name: 'ranking',
      component: () => import('@/pages/read/book/book_ranking.vue')
    },
    {
      // 个人空间
      path: '/read/space',
      name: 'space',
      meta: {share: true},
      component: () => import('@/pages/read/book/space.vue')

    },
    {
      // 发布语音页
      path: '/read/issue',
      name: 'issue',
      component: () => import('@/pages/read/book/book_read.vue')

    },
    {
      // 直播专区页
      path: '/read/live',
      name: 'live',
      component: () => import('@/pages/read/live/video_live.vue')
    },
    {
      // 分享页
      path: '/read/share',
      name: 'share',
      meta: {allowBack: false, share: true},
      component: () => import('@/pages/read/share/share.vue')
    },
    {
      // 公共维护页
      path: '/read/base',
      name: 'base',
      meta: {index: 0, allowBack: false},
      component: () => import('@/pages/read/base/base.vue')
    },
    // 夜谈首页
    {
      path: '/radio/index',
      name: 'radioIndex',
      component: () => import('@/pages/radio/radio_index.vue')
    },
    {
      // 上部均未匹配到则重定向至书单首页
      path: '*',
      meta: {index: 0, allowBack: false},
      redirect: {name: 'home'}
    }
  ]
})

// 路由拦截
router.beforeEach((to, from, next) => {
  // 除去特殊分享的页面(一般页面)
  var shareData = sessionStorage.getItem('initData')
  if (to.name != 'onboarding' && !to.meta.share) {
    if (shareData) {
      shareApi.baseConfig(JSON.parse(shareData).share, function (res) {
        sessionStorage.setItem('noticeUnread', res.notice_unread)
        var s = new Date(res.onboarding.start_time.replace(/-/g, '/')).getTime()
        var e = new Date(res.onboarding.end_time.replace(/-/g, '/')).getTime()
        var n = new Date().getTime()
        // 时间一致
        if (n > s && n < e && res.onboarding.status == '1') {
          // key一致
          if (localStorage.getItem('onboarding') == res.onboarding.key) {
            next()
          } else {
            sessionStorage.setItem('boardBack', window.location.origin + to.fullPath)
            router.replace({path: '/onboarding'})
          }
        } else {
          next()
        }
      }, window.location.origin + to.fullPath)
    } else {
      var params = {
        sharetype: 'default'
      }
      api.getShare(params).then((res) => {
        let sv = res.share
        sessionStorage.setItem('initData', JSON.stringify(res))
        shareApi.baseConfig(sv, function (res) {
          sessionStorage.setItem('noticeUnread', res.notice_unread)
          var s = new Date(res.onboarding.start_time.replace(/-/g, '/')).getTime()
          var e = new Date(res.onboarding.end_time.replace(/-/g, '/')).getTime()
          var n = new Date().getTime()
          if (n > s && n < e && res.onboarding.status == '1') {
            // key一致
            if (localStorage.getItem('onboarding') == res.onboarding.key) {
              next()
            } else {
              sessionStorage.setItem('boardBack', window.location.origin + to.fullPath)
              router.replace({path: '/onboarding'})
            }
          } else {
            next()
          }
        })
      }, window.location.origin + to.fullPath)
    }
  } else {
    next()
  }
})
// router.beforeEach((to, from, next) => {
//   // 除去特殊分享的页面(一般页面)
//   var shareData = sessionStorage.getItem('initData')
//   if (to.name != 'onboarding' && !to.meta.share) {
//     var onboarding = localStorage.getItem('onboarding')
//     if (onboarding) {
//       next()
//     } else {
//       if (shareData) {
//         shareApi.baseConfig(JSON.parse(shareData).share, function (res) {
//           sessionStorage.setItem('noticeUnread', res.notice_unread)
//           var s = new Date(res.onboarding.start_time.replace(/-/g, '/')).getTime()
//           var e = new Date(res.onboarding.end_time.replace(/-/g, '/')).getTime()
//           var n = new Date().getTime()
//           // 时间一致
//           if (n > s && n < e && res.onboarding.status == '1') {
//             // key一致
//             if (localStorage.getItem('onboarding') == res.onboarding.key) {
//               next()
//             } else {
//               sessionStorage.setItem('boardBack', window.location.origin + to.fullPath)
//               router.replace({path: '/onboarding'})
//             }
//           } else {
//             next()
//           }
//         })
//       } else {
//         var params = {
//           sharetype: 'default'
//         }
//         api.getShare(params).then((res) => {
//           let sv = res.share
//           sessionStorage.setItem('initData', JSON.stringify(res))
//           shareApi.baseConfig(sv, function (res) {
//             sessionStorage.setItem('noticeUnread', res.notice_unread)
//             var s = new Date(res.onboarding.start_time.replace(/-/g, '/')).getTime()
//             var e = new Date(res.onboarding.end_time.replace(/-/g, '/')).getTime()
//             var n = new Date().getTime()
//             if (n > s && n < e && res.onboarding.status == '1') {
//               // key一致
//               if (localStorage.getItem('onboarding') == res.onboarding.key) {
//                 next()
//               } else {
//                 sessionStorage.setItem('boardBack', window.location.origin + to.fullPath)
//                 router.replace({path: '/onboarding'})
//               }
//             } else {
//               next()
//             }
//           })
//         })
//       }
//     }
//   } else {
//   next()
//   }
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js